import React, { Component } from "react"
import { connect } from 'react-redux';
import Service from '../../../services';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { BasicLazyParams } from '../../../utile';
import Authentication from './../../session';
import _ from 'lodash';
import { BoardsIconInActive, CancelRed, CrossInBox, GreenCheck } from '../../svgIcons';
import LoadingComponent from '../../loadingComponent';
import { baseUrlAdmin } from './../../../store/apiConstants';
import withRouter from '../../lib/withRouter';
import './styles.scss'
import { debounce } from 'lodash';
import ClassetDropdown from "../../../classetComponents/classetDropDown";
import { getBranchesLatest } from "../../../store/actions";
import BranchToSectionApprovalHierarchy from "../../BaseDropdownComponents/BranchToSectionApprovalHierarchy";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';

// const searchTypeOptions = [
//     { label: "Student Name", value: "studentName" },
//     { label: "Enrollment Number", value: "enrollmentNumber" }
// ]
class TransferPendingStudents extends Component {
    constructor(props) {
        super(props);
        this.studentSearchRef = React.createRef();
        this.state = {
            isLoading: false,

            filterData: null,

            columns: [
                { columnName: 'Created At', isVisible: false, id: 'createDateTime' }],

            isUserNameSearch: false,
            username: '',
            boardId: null,
            classId: null,
            groupId: null,
            sectionIds: [],
            boards: [],
            classes: [],
            groups: [],
            sections: [],
            branchLevels: {},
            lazyParams: BasicLazyParams,
            transfers: [],
            selectedUser: [],
            globalSearch: '',
            totalRecords: 0,
            isDialogOpenForApproveStudent: false,
            isRejectTransferDialogOpen: false,
            rowData: {},
            dropdownsData: {}, // Ensure this is always an object
            flagForTransfer: null,
            isUserNameSearch: false,
            isUserEnrollSearch: false,
            searchValue: "",
            searchLevel: 1,
            // searchType: searchTypeOptions[0].value,
            branchId: null,
            branchName: null,
            dropdownsDilogData: {},
            filterbranchId: this.props.branchData && this.props.branchData.find(e => e.key == this.props.branchData[0].key)?.key,
            focused: false,
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'enrollmentId': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            },
            globalFilterValue: '',


        };
        this.debouncedApiCall = debounce(this.filterUsersData, 500);
        this.service = new Service();

    }

    setDropdownValuesDilog = (dropdownsData) => {

        this.setState(prevState => ({
            dropdownsDilogData: dropdownsData,
            rowData: {
                ...prevState.rowData,
                tosectionName: dropdownsData?.selectedsectionName,
                tosectionId: dropdownsData?.sectionId,
                toTransferStatus: this.state?.flagForTransfer
            }
        }),
            () => {
                this.filterUsersData(dropdownsData)
            })
    }



    setDropdownValues = (dropdownsData, payload = {}) => {
        this.setState({
            dropdownsData,
            studentIds: payload?.studentIds || [],
            enrollmentIds: payload?.enrollmentIds || [],
        }, () => this.filterUsersData());
    }


    filterUsersData = () => {
        this.setState({
            isLoading: true,
            transfers: []
        });


        let { globalSearch, filterData } = this.state;

        // For client-side pagination, get all records at once
        const url = `${baseUrlAdmin}/transfers/get/all?academicYear=${localStorage.getItem('userAcademicYear')}&limit=1000&page=1&search=${globalSearch}`;

        let payload = {
            branchId: this.state.dropdownsData?.branchIds || [],
            boardId: this.state.dropdownsData?.boardIds || [],
            gradeId: this.state.dropdownsData?.classIds || [],
            sectionId: this.state.searchLevel == 1 && this.state.dropdownsData?.sectionId,
            // isUserNameSearch: this.state.searchLevel == 2 && this.state.searchType == "studentName" ? true : this.state.isUserNameSearch,
            // username: this.state.searchValue,
            assignedHeirarchy: this.state.dropdownsData?.heirarchy
        };
        
        // if (this.state.searchLevel === 2) {
        //     // payload.branchIds = this.state.dropdownsData?.branchIds || [];
        //     payload.studentIds = this.state.dropdownsData?.studentIds || [];
        // }
        // Fix: Always check for array before accessing length
        if ((Array.isArray(payload.branchId) && payload.branchId.length) || (Array.isArray(payload.studentIds) && payload.studentIds.length) || (this.state.searchValue && this.state.searchValue.length)) {
            this.service.post(url, payload, true).then(res => {
                if (res && res.status && res.res.status) {
                    this.setState({
                        isLoading: false,
                        transfers: res.res?.data?.data,
                        totalRecords: res.res?.data?.totalRecords,
                        isUserNameSearch: false,
                        isUserEnrollSearch: false,
                        searchValue: "",
                    });
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
                }
            }).catch(e => {
                this.setState({
                    isLoading: false
                });
                console.log(e);
            });
        } else {
            this.setState({
                isLoading: false
            });
        }

    }
    componentDidMount() {

        if (this.state?.dropdownsData?.sectionId) {
            this.filterUsersData();

        }
        // this.props.getBranchesLatest();
    }

    onSearchClick = (filterData) => {

        this.setState({
            filterData
        }, this.filterUsersData)


    }
    // For client-side pagination, we don't need a custom onPage handler
    // as PrimeReact handles this internally

    // For client-side sorting, we don't need a custom sort handler
    // as PrimeReact handles this internally

    onFilter = (event) => {
        // For client-side filtering, just update the filters in state
        this.setState({
            filters: event.filters
        });
    }

    rejectedData = () => {

        this.setState(prevState => ({
            isRejectTransferDialogOpen: true,
            rowData: {
                ...prevState.rowData,
                toTransferStatus: this.state?.flagForTransfer
            }
        }), () => {
            if (this.state?.isRejectTransferDialogOpen) {
                this.updateTransfer()

            }

        })
    }

    acceptedData = () => {


        this.setState(prevState => ({
            isDialogOpenForApproveStudent: true,
            rowData: {
                ...prevState.rowData,
                toTransferStatus: this.state?.flagForTransfer
            },
        }), () => {
            console.log(this.state.toTransferStatus, this.state.rowData, "iiii", this.state.branchId)
            if (this.state?.isDialogOpenForApproveStudent) {
                this.updateTransfer()
            }
        })
    }
    updateTransfer = () => {



        if (this.state?.rowData && Object.keys(this.state?.rowData).length) {

            const { rowData } = this.state;
            let payload;
            if (rowData.transferType == "Section") {
                payload = rowData
            } else if (rowData.transferType == "Branch") {
                const branchName = this.state.branchId && this.props.branchData.find(e => e.key == this.state.branchId)?.name;
                payload = { ...rowData, tobranchId: this.state.branchId, tobranchName: branchName }
                console.log(payload, this.state?.rowData, "this.state?.rowData", this.state.rowData.tobranchId, this.state.branchId)
            }
            // payload = { ...payload, handledBy: localStorage.getItem('userId'), handledByName: localStorage.getItem('username') }
            payload = {
                ...payload,
                handledBy: rowData?.handledBy || [],
                levelAndBranchDetails: this.state.dropdownsData?.heirarchy?.adminLevels?.filter((al) => al._id == rowData?.fmbranchId)
            }
            this.setState({
                isLoading: true
            })
            let url = `${baseUrlAdmin}/transfers/update`
            this.service.post(url, payload, true).then(res => {
                if (res?.status && res?.res?.status) {
                    this.setState({
                        isDialogOpenForApproveStudent: false,
                        isRejectTransferDialogOpen: false,
                        isLoading: false
                    }, () => { })

                    this.toast.show({ severity: 'success', summary: `Successfully ${this.state?.flagForTransfer}`, detail: res.errMessage, life: 3000 });
                    this.filterUsersData()

                } else {
                    this.setState({
                        isLoading: false
                    })
                    this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
                }
            }).catch(err => {
                this.setState({
                    isLoading: false
                })
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: err.message, life: 3000 });
            })
        } else {
            this.setState({
                isLoading: false
            })
            this.toast.show({ severity: 'error', summary: `Assign Records shouldn't not empty`, detail: "Please select Atleast one record", life: 3000 });

        }
    }


    handleSetSearchTypeValue = (value) => {
        this.setState({ searchType: value }, () => {
            if (this.state.searchType == "studentName") {
                this.setState({ isUserNameSearch: true })
            } else {
                this.setState({ isUserEnrollSearch: true })
            }

        })
    }

    handleSetSearchValue = (value) => {
        this.setState({ searchValue: value }, () => {

            this.debouncedApiCall(this.state.searchValue);

        })
    }

    handleSearchLevel = (value) => {
        this.setState({ searchLevel: value }, () => {
            this.filterUsersData()
        })
    }


    handleFocus = () => {
        if (this.state.searchLevel == 3) {
            this.setState({ focused: true }, () => {

            })

        }

    };

    handleBlur = () => {
        if (this.state.searchLevel == 3) {
            this.setState({ focused: false }, () => {

            })
        }

    };
    onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let filters = { ...this.state.filters };
        filters['global'].value = value;
        this.setState({ filters, globalFilterValue: value });
    };

    renderHeader() {
        return (
            <div className="flex justify-content-between align-items-center">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText
                        value={this.state.globalFilterValue}
                        onChange={this.onGlobalFilterChange}
                        placeholder="Id / Phone Number / Branch"
                    />
                </span>
            </div>
        );
    }
    render() {

        const header = this.renderHeader();
        return (
            <div>


                <div className='ma-main  '>

                    <div className=" datatable-crud-demo ma-m30 mx-2 mb-5">
                        <div className="flex">
                            {/*    <div className="flex flex-column justify-content-center align-items-center mt-3" >
                                <RadioButton inputId="ingredient1" onChange={(e) => this.handleSearchLevel(1)} checked={this.state.searchLevel === 1} />
                            </div>
 */}
                            <div>
                                <BranchToSectionApprovalHierarchy selectedValue={this.state.searchLevel} setValues={this.setDropdownValues} approvalType={'studentTransfer'} />
                            </div>
                        </div>
                        {/* <div style={{ marginLeft: "100px" }} className="flex justify-content-start align-items-center">
                            <span className="">OR</span>
                        </div> */}
                        {/* <ClassetStudentSearch selectedValue={this.state.searchLevel} handleTypeValue={this.handleSetSearchTypeValue} handleSearchValue={this.handleSetSearchValue} /> */}
                        {/* <div className="flex mt-4 " >
                            <div className="flex flex-column justify-content-center align-items-center mt-3">
                                <RadioButton inputId="ingredient2" onChange={(e) => this.handleSearchLevel(2)} checked={this.state.searchLevel === 2} />
                            </div>
                            <div className="field ml-4">
                                <ClassetStudentSearchFilter
                                    ref={this.studentSearchRef}
                                    selectedValue={this.state.searchLevel}
                                    setValues={this.setDropdownValues}
                                />
                            </div>
                        </div> */}
                        {/* <div className="flex mt-4" onClick={this.handleFocus} >
                            <div className="flex flex-column justify-content-center align-items-center -mt-3">
                                <RadioButton inputId="ingredient2" onChange={(e) => this.handleSearchLevel(3)} checked={this.state.searchLevel === 3} />
                            </div>

                            <div className="field ml-4">
                                <ClassetDropdown required={true} label={'Branch'} icon={<BoardsIconInActive height={16.5} width={19.5} />} placeholder={'Select Branch'} options={this.props?.branchData}
                                    value={this.state.filterbranchId} onChange={(e) => this.setState({ filterbranchId: e.value }, () => { this.filterUsersData() })} optionLabel="name"
                                    optionValue="key" onFocus={this.handleFocus} onBlur={this.handleBlur} disabled={this.state.searchLevel === 3 ? false : true} />
                            </div>
                        </div> */}

                    </div>


                    <div className="card datatable-crud-demo ma-m30  m-2">

                        <DataTable
                            ref={(el) => this.dt = el}
                            value={this.state.transfers}
                            dataKey="_id"
                            className="dataTableValuesText"
                            responsiveLayout="scroll"
                            showGridlines
                            columnResizeMode="expand"
                            resizableColumns
                            paginator
                            rows={10}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            header={header}
                            rowHover
                            lazy={false} // Set to false for client-side pagination
                            selection={this.state.selectedRows}
                            onSelectionChange={this.onSelectionChange}
                            filters={this.state.filters}
                            onFilter={this.onFilter}
                            filterDisplay="menu"
                            loading={this.state.isLoading}
                            emptyMessage="No records found"
                            globalFilterFields={['name', 'enrollmentId', 'phoneNumber', 'fmbranchName', 'tobranchName', 'fmsectionName', 'tosectionName', 'fmboradName', 'toboradName', 'fmclassName', 'toclassName']}
                        >

                            <Column style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} headerClassName="text-color-secondary" bodyClassName='text-center' filterField="totalStudents" field="transferType" header="Transfer Type" />


                            <Column
                                style={{ width: "15rem", height: "6rem" }}
                                alignHeader={"center"}
                                headerClassName="text-color-secondary"
                                bodyClassName='text-center'
                                filterField="name"
                                field="name"
                                header="Enrollment Id"
                                body={(rowData) => rowData?.name ? rowData.name.substring(3, rowData.name.length) : ''}
                            />

                            <Column style={{ width: "17rem", height: "6rem" }} alignHeader={"center"} headerClassName="text-color-secondary" bodyClassName='text-center' filterField="contactNumber" field="fmbranchName - tobranchName" header=" From Branch - To Branch" body={(rowData, index) => {
                                return (
                                    <>
                                        {
                                            rowData.transferType == "Branch" && <div>
                                                {rowData.fmbranchName}-{rowData.tobranchName}
                                            </div>}
                                    </>
                                )


                            }} />
                            {/*      <Column style={{ width: "15rem", height: "6rem" }} alignHeader={"center"}  headerClassName="text-color-secondary" bodyClassName='text-center' filterField="creationDate" field="fmboradName - toboradName" header=" From Board - To Board" 
                             body={(rowData, index) => {
                                return (
                                    <>  
                                        <div>
                                            {rowData.fmboradName}-{rowData.toboradName}
                                        </div>
                                    </>
                                )


                            }}/>

                            <Column style={{ width: "15rem", height: "6rem" }} alignHeader={"center"}  headerClassName="text-color-secondary" bodyClassName='text-center' filterField="totalStaff" field="fmclassName - toclassName" header="From Grade- To Grade" 
                            body={(rowData, index) => {
                                return (
                                    <>  
                                        <div>
                                            {rowData.fmclassName}-{rowData.toclassName}
                                        </div>
                                    </>
                                )


                            }}/> */}
                            <Column style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} headerClassName="text-color-secondary" bodyClassName='text-center' filterField="totalStaff" field="fmsectionName - tosectionName" header="From Section -To Section" body={(rowData, index) => {
                                return (
                                    <>
                                        {
                                            rowData.transferType == "Section" && <div>
                                                {rowData.fmsectionName}-{rowData.tosectionName}
                                            </div>
                                        }
                                    </>
                                )


                            }} />

                            <Column style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} headerClassName="text-color-secondary" bodyClassName='text-center' filterField="phoneNumber" field="phoneNumber" header="Phone Number" />

                            <Column style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} headerClassName="text-color-secondary" bodyClassName='text-center' filterField="status" field="status" header="Status" />

                            <Column style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} headerClassName="text-color-secondary" bodyClassName='text-center' className=' ' header="Approve / Reject" body={(rowData, { rowIndex }) => {
                                return (
                                    <div className="flex justify-content-evenly">
                                        <div className="cursor-pointer" onClick={() => this.setState({
                                            isDialogOpenForApproveStudent: true, rowData: rowData, branchId: rowData?.tobranchId, branchName: rowData?.tobranchName
                                            , flagForTransfer: "APROVE"
                                        })}>
                                            <GreenCheck />
                                        </div>

                                        <div className="cursor-pointer" onClick={() =>
                                            this.setState({
                                                isRejectTransferDialogOpen: true, rowData: rowData, branchId: rowData?.tobranchId, branchName: rowData?.tobranchName
                                                , flagForTransfer: "REJECT"
                                            })
                                        }>
                                            <CancelRed />
                                        </div>

                                    </div>
                                )
                            }} ></Column>


                        </DataTable>

                        <Toast ref={(el) => this.toast = el} position="bottom-right" />
                        <Dialog
                            visible={this.state.isDialogOpenForApproveStudent}
                            draggable={false}
                            closeOnEscape={false}
                            className=' mr-0'
                            style={{}}
                            dismissableMask={false}
                            closable={false}
                            header={() => {
                                return (<div className='mt-1'>
                                    <h4 className="sideHeading" style={{ fontSize: 36, color: 'black' }}>Assign Transfer Student </h4>
                                    <div style={{ backgroundColor: 'black', height: 2, width: '100%', padding: 0 }}></div>
                                </div>)
                            }}
                            footer={() => (
                                <div className="" style={{ display: 'flex' }}>
                                    <Button style={{ borderRadius: 10, backgroundColor: '#076EFF', width: '170%', padding: 0, justifyContent: 'center', alignItems: 'center' }} onClick={() => { this.acceptedData() }}>
                                        <p className='text-xl ml-2'>Accept & Assign</p>
                                    </Button>
                                    <Button style={{ borderRadius: 10, backgroundColor: '#E0E0E0', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', border: 0 }} onClick={() => { this.setState({ isDialogOpenForApproveStudent: false }) }}>
                                        <p className='text-xl'>Cancel</p>
                                    </Button>
                                </div>
                            )}
                            onHide={() => this.setState({ isDialogOpenForApproveStudent: false })}
                        >

                            <p className="topicName ml-6" style={{ color: 'black', alignSelf: 'center', paddingBottom: 10 }}>
                                <p>Student Name : {this.state?.rowData?.name}</p>
                                {/* <p>Enrollment no: 23M108708</p> */}
                                <p>Transferred from : {this.state?.rowData?.transferType}</p>
                                <p>Board: {this.state?.rowData?.fmboradName}</p>
                                <p>Grade-Section :{this.state?.rowData?.fmclassName} - {this.state?.rowData?.fmsectionName}</p>
                                {/* <p>Contact Person : Parent Name</p> */}
                                <p>Phone number : {this.state?.rowData?.phoneNumber}</p>
                                <p>Request Raised by : {this.state?.rowData?.requestRaisedByName?.slice(3)}</p>
                            </p>

                            <div style={{ backgroundColor: 'black', height: 2, width: '100%', padding: 0 }}></div>




                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                {this.state.rowData?.transferType == "Branch" &&

                                    <div className="row-3 my-2">
                                        <ClassetDropdown required={true} label={'Branch'} icon={<BoardsIconInActive height={16.5} width={19.5} />} placeholder={'Select Branch'} options={this.props?.branchData}
                                            value={this.state.branchId} onChange={(e) => this.setState({ branchId: e.value })}
                                            disabled={true}
                                            optionLabel="name"
                                            optionValue="key" />
                                    </div>



                                }
                                {this.state.rowData?.transferType == "Section" &&
                                    <div className="row-3 my-2">
                                        <p className="topicName" style={{ color: 'black', alignSelf: 'center', paddingBottom: 10 }}> Section Change from {this.state.rowData?.fmsectionName}  to {this.state.rowData?.tosectionName} </p>
                                    </div>
                                }
                            </div>








                        </Dialog>
                        <Dialog
                            visible={this.state.isRejectTransferDialogOpen}
                            draggable={false}
                            closeOnEscape={false}
                            className='w-3'
                            dismissableMask={false}
                            closable={false}
                            header={() => {
                                return (<div className='formHeadingInter' style={{}}>
                                    <CrossInBox bgcolor={'#BF0031'} color={'white'} />
                                </div>)
                            }}
                            footer={() => (
                                <div className='flex justify-content-center '>
                                    <Button className='formSubmitButton px-6' style={{ border: 0 }} onClick={() => { this.rejectedData(this.state?.rowData) }} >
                                        <p className='formSubmitButtonText'>Reject</p>
                                    </Button>
                                    <Button className='formCancelButton px-4' style={{ backgroundColor: '#F4F5F6', border: 0 }} onClick={() => this.setState({ isRejectTransferDialogOpen: false })} >
                                        <p className='formCancelButtonText'>Cancel</p>
                                    </Button>
                                </div>
                            )}
                            onHide={() => this.setState({ isRejectTransferDialogOpen: false })}
                        >
                            <div>
                                <p className='sideHeading' style={{ fontSize: 20,textAlign: 'center' }}>Reject Transfer</p>
                                <p className="topicName" style={{ color: 'black', alignSelf: 'left', }}>
                                    <p>Student Name : {this.state?.rowData?.name}</p>
                                    {/* <p>Enrollment no: 23M108708</p> */}
                                    <p>Transferred from : {this.state?.rowData?.transferType}</p>
                                    <p>Board: {this.state?.rowData?.fmboradName}</p>
                                    <p>Grade-Section :{this.state?.rowData?.fmclassName} - {this.state?.rowData?.fmsectionName}</p>
                                    {/* <p>Contact Person : Parent Name</p> */}
                                    <p>Phone number : {this.state?.rowData?.phoneNumber}</p>
                                    <p>Request Raised by : {this.state?.rowData?.requestRaisedByName?.slice(3)}</p>
                                </p>
                            </div>

                        </Dialog>
                        {this.state.isLoading && <LoadingComponent />}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStatesToProps = (state) => ({

    branchData: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.data.filter((each => {
        if (each.level == 1) {
            return { ...each }
        }
    })) || [],
});
export default connect(mapStatesToProps, {
    getBranchesLatest
})(Authentication(withRouter(TransferPendingStudents)));